'use client';

import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { AsideTopEntitiesList } from '@/components/shared';
import { AppRoutes } from '@/i18n/constants';
import { FeatureFlag, useFeatureFlag } from '@/libs/feature-flags/client';
import { isStaging } from '@/libs/getEnvironment';
import { bestProvidersQueryOptions } from '@/queries/publicSidebars.queries';

export const BestProviders = () => {
  const t = useTranslations('providers');
  const hideForWebhookTest = useFeatureFlag(FeatureFlag.QA_HIDE_BEST_PROVIDERS_ENABLED);

  const { data: providers } = useQuery(bestProvidersQueryOptions());

  if ((isStaging() && hideForWebhookTest) || !providers || !providers?.items) {
    return null;
  }

  const transformedProviders = providers.items.map(provider => ({
    name: provider.name,
    href: AppRoutes.providersSlugPaged(provider.alias),
  })) ?? [];

  return <AsideTopEntitiesList title={t('best-providers')} list={transformedProviders} />;
};
